// src/App.tsx
import { Suspense } from "react";
import { useRoutes } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, CircularProgress, Typography } from "@mui/material";
import routes from "./routes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AuthHandler from "./components/AuthNavigationHandler";
import { CompanyProvider } from "./contexts/CompanyContext";
import "./utils/authReset"; // Import auth reset utility
import './index.css';
function App() {
  const routing = useRoutes(routes);
  const { t } = useTranslation();

  const LoadingFallback = () => (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      gap={2}
    >
      <CircularProgress size={48} thickness={4} />
      <Typography variant="body1" color="text.secondary">
        {t("common.loading")}
      </Typography>
    </Box>
  );

  return (
    <CompanyProvider>
      <AuthHandler />
      <ToastContainer position="top-right" autoClose={3000} />
      <Suspense fallback={<LoadingFallback />}>{routing}</Suspense>
    </CompanyProvider>
  );
}

export default App;
